import React from 'react'
import PropTypes from 'prop-types'
import Tab from './Tab'

const Tabs = ({className, options, optionActive, setOptionActive}) => {

  const renderItems = options.map((item) => {
    const { id, category } = item
    return (
      <Tab
        key={id}
        id={id}
        title={category} 
        tabActive={optionActive} 
        setTabActive={setOptionActive}/>
    )
  })

  return (
    <div className={`tabs ${className}`}>
      {renderItems}
    </div>
  )
}

Tabs.propTypes = {
  className: PropTypes.string,
  optionActive: PropTypes.number.isRequired,
  setOptionActive: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired
}

Tabs.defaultProps = {
  className: ""
}

export default Tabs
